/* HVAC-072-DI */
(function () {
  var STORAGE_KEY = 'hvac-072-di-call-banner-dismissed';
  var root = document.querySelector('[data-sticky-call-banner]');
  if (!root) return;

  try {
    if (window.sessionStorage.getItem(STORAGE_KEY) === '1') {
      root.classList.add('is-dismissed');
      root.setAttribute('hidden', '');
      return;
    }
  } catch (e) {
    /* sessionStorage unavailable */
  }

  var closeBtn = root.querySelector('[data-sticky-call-banner-close]');
  if (!closeBtn) return;

  closeBtn.addEventListener('click', function () {
    root.classList.add('is-dismissed');
    root.setAttribute('hidden', '');
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* sessionStorage unavailable */
    }
  });
})();
